import { Button } from "../../Button";
import { Input } from "../../Input";
import { Modal } from "../../Modal";

interface JoinRoomModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSubmit: (e: React.FormEvent) => void;
  displayName: string;
  onDisplayNameChange: (value: string) => void;
  displayNameError?: string;
  sessionIdInput: string;
  onSessionIdChange: (value: string) => void;
  joinError: string | null;
  submitting: boolean;
  isAuthenticated: boolean;
}

export function JoinRoomModal({
  isOpen,
  onClose,
  onSubmit,
  displayName,
  onDisplayNameChange,
  displayNameError,
  sessionIdInput,
  onSessionIdChange,
  joinError,
  submitting,
  isAuthenticated,
}: JoinRoomModalProps) {
  const handleClose = () => {
    onClose();
  };

  return (
    <Modal isOpen={isOpen} onClose={handleClose} title="Join with Magic Words">
      <form
        onSubmit={onSubmit}
        className="space-y-6"
        data-testid="modal-join-form"
      >
        {!isAuthenticated && (
          <Input
            label="Your Name"
            value={displayName}
            onChange={(e) => onDisplayNameChange(e.target.value)}
            placeholder="Enter your display name"
            required
            maxLength={50}
            error={displayNameError}
            data-testid="modal-join-name-input"
          />
        )}
        <Input
          label="Magic Words"
          value={sessionIdInput}
          onChange={(e) => onSessionIdChange(e.target.value)}
          placeholder="e.g., 8 hamsters, 2 palettes, 9 computers"
          required
          data-testid="modal-join-code-input"
        />
        {joinError && (
          <div
            className="p-3 rounded-lg font-medium"
            style={{ backgroundColor: "var(--color-error)", color: "#ffffff" }}
            data-testid="modal-join-error"
          >
            ⚠️ {joinError}
          </div>
        )}
        <div className="flex gap-4 pt-4">
          <Button
            type="submit"
            variant="primary"
            disabled={submitting}
            className="flex-1"
            data-testid="modal-join-submit"
          >
            {submitting ? "Joining..." : "Join Room"}
          </Button>
          <Button
            type="button"
            variant="secondary"
            onClick={handleClose}
            data-testid="modal-join-cancel"
          >
            Cancel
          </Button>
        </div>
      </form>
    </Modal>
  );
}
